module.exports = __webpack_public_path__ + "img/emoji-stop-240x240.95dda817.png";